export default __webpack_public_path__ + "static/media/BeatthePeak_Home_Banner_v2.0dfd81db.jpg";